import React from 'react';
import CustomNavbar from '../CustomNavbar';
import SidebarDashboard from '../SidebarDashboard';
import { Container } from 'react-bootstrap';


const MainContainer = ({children}) => {
  const [showSidebar, setShowSidebar] = React.useState(false);
  const onShowSidebar = () => setShowSidebar(!showSidebar);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={showSidebar} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          {children}
        </Container>
      </div>
    </>
  )
}

export default MainContainer